import ContactCard from "./components/contactus/ContactCard";
export default ()=> <ContactCard />